"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const compact_1 = require("./compact");
/*
 * Slice object to include only the given keys.
 *
 * @Param {Object} object = Object to slice.
 * @Param {...String}     = Subset of keys in object to slice.
 *
 * @Example
 *
 *    slice({ pizza: 'Mm', pasta: 'Ah', spinach: 'Ew' }, 'pizza', 'pasta');
 *    //=> { pizza: 'Mm', pasta: 'Ah' }
 */
function slice(object, ...keys) {
    const newObject = keys.reduce((acc, key) => (Object.assign({}, acc, { [key]: object[key] })), {});
    return compact_1.compact(newObject);
}
exports.slice = slice;
//# sourceMappingURL=slice.js.map